import { ServiceRequirement, TransferPreferencesDef } from "./definitions";

type QuotationTransferProps = {
  transfer: ServiceRequirement;
  index: number;
  excludedServiceUids: Set<string>;
  excludeSrv: (uid: string) => void;
  includeSrv: (uid: string) => void;
};

export function QuotationTransfer({
  transfer,
  index,
  excludedServiceUids,
  excludeSrv,
  includeSrv,
}: QuotationTransferProps) {
  const preferences = transfer.preferences as TransferPreferencesDef;

  return (
    <div
      key={`${index}-${transfer.service_date}`}
      className="px-2 inline-grid gap-2 bg-blue-100 rounded-md p-1"
    >
      <div className="grid grid-cols-[max-content_1fr_max-content] gap-2 items-start">
        <strong>{index + 1}. </strong>
        <span>{transfer.notes}</span>
        <input
          type="checkbox"
          checked={!excludedServiceUids.has(transfer.uid)}
          className="self-center"
          onChange={(e) => {
            if (e.target.checked) {
              includeSrv(transfer.uid);
            } else {
              excludeSrv(transfer.uid);
            }
          }}
        />
      </div>
      {(preferences.big_luggage_capacity > 0 || preferences.small_luggage_capacity > 0) && (
        <div className="grid grid-flow-col gap-2 items-center auto-cols-max">
          {preferences.big_luggage_capacity > 0 && (
            <span className="border border-blue-300 rounded-md p-1">
              <strong>Big Luggage Capacity: </strong>
              {preferences.big_luggage_capacity}
            </span>
          )}
          {preferences.small_luggage_capacity > 0 && (
            <span className="border border-blue-300 rounded-md p-1">
              <strong>Small Luggage Capacity: </strong>
              {preferences.small_luggage_capacity}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
